export default __webpack_public_path__ + "static/service-1-60d7a9829eefef12b73c86f7ad355a30.jpg";